import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  getApiPartnersOptions,
  type GetApiPartnersError,
  type PageOfPartnerDto,
} from '@/api';

import {
  toCustomersQuery,
  type ResolvedCustomersSearch,
} from '../lib/searchParams';

/** Клиенты - партнёры 1С с признаком «Клиент», страница по фильтрам из адреса. */
export const useCustomersList = (
  resolved: ResolvedCustomersSearch,
): UseQueryResult<PageOfPartnerDto, GetApiPartnersError> =>
  useQuery({
    ...getApiPartnersOptions({ query: toCustomersQuery(resolved) }),
    placeholderData: (previous) => previous,
  });
